// src/prototype/components/TeamList.tsx
// Initiative team. Seats with no named person show their title in the name slot —
// the demo cast is deliberately limited, so unnamed roles stay unnamed.
import React from 'react';
import type { TeamMember } from '../data/executionInitiatives';

const initials = (s: string) =>
  s
    .split(' ')
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('');

export interface TeamListProps {
  team: TeamMember[];
}

export const TeamList: React.FC<TeamListProps> = ({ team }) => (
  <ul className="space-y-2.5">
    {team.map((member) => {
      const primary = member.name || member.title;
      return (
        <li key={member.role} className="flex items-center gap-2.5">
          <span className="w-7 h-7 rounded-full bg-[#18365E] text-white text-[10px] font-bold flex items-center justify-center shrink-0">
            {initials(primary)}
          </span>
          <div className="min-w-0">
            <p className="text-xs font-bold text-[#18365E] leading-tight">{primary}</p>
            <p className="text-[10px] text-[#717182]">
              {member.role}
              {member.name ? ` · ${member.title}` : ''}
            </p>
          </div>
        </li>
      );
    })}
  </ul>
);

export default TeamList;
